import { render, staticRenderFns } from "./RePagination.vue?vue&type=template&id=7dbd54e0&"
import script from "./RePagination.vue?vue&type=script&lang=js&"
export * from "./RePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports